import _ from "underscore";
import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

function matchIds(requestData, responseData) {
  return responseData.map(issue => {
    const result = {
      ...requestData[issue.id],
      ...issue,
    };
    return _.omit(result, "added_contract_types", "removed_contract_types");
  });
}

export default function updateIssues(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.ISSUES_UPDATE,
    (organisationId, data) => {
      return requestor
        .patch(`${basePath}/organisation/${organisationId}/issue`, data, {
          withCredentials: true,
        })
        .then(response => matchIds(data, response.data));
    },
  );

  return action;
}
